import styled from 'styled-components'
import styledMap from 'styled-map'
import { helpers } from '@/atoms/Typography'

export const StyledRichtext = styled.span`
  ${helpers};

  /* Ensure CMS content wraps and doesn't clip on text zoom */
  white-space: normal;
  overflow-wrap: break-word;
  word-break: normal;
  // If you see too many hyphens… disable this
  //hyphens: auto;
  //-webkit-hyphens: auto;
  //-ms-hyphens: auto;

  strong,
  b {
    font-weight: 600;
  }

  em {
    font-style: italic;
  }

  a {
    text-decoration: underline;
  }

  color:${({ theme }) => styledMap`
    default: inherit;
    white: ${theme.colors.grayscale.white};
    accent:${theme.colors.accent()};
    background:${theme.colors.background()};
    medium:${theme.colors.medium()};
  `};

  ${({
    theme,
    typo
  }) => typo && theme.typo(typo)};
`
